import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { TeamsLinkButton } from '@atlaskit/teams-app-internal-navigation/teams-link-button';

import type { PersonProfileData } from '../../types';

const messages = defineMessages({
	suggestChanges: {
		id: 'user-profile-preview.SuggestCollaboratorChanges.suggestChanges',
		defaultMessage: 'Suggest Changes',
		description:
			'Link to suggest changes to the focused user’s collaborators in User Shard Explorer',
	},
});

/** Opens collaborator feedback for the focused profile when enabled. */
export function SuggestCollaboratorChanges({
	profileData,
	orgId,
}: {
	profileData: PersonProfileData;
	orgId?: string;
}): React.JSX.Element | null {
	const intl = useIntl();
	if (!fg('kd_user_profile_card_cg_feedback') || !profileData.accountId) {
		return null;
	}

	const data = encodeURIComponent(
		JSON.stringify({
			accountId: profileData.accountId,
			email: profileData.email,
			name: profileData.name,
			picture: profileData.avatarUrl,
			nickname: profileData.name,
			jobTitle: profileData.jobTitle,
			organization: profileData.organization,
			department: profileData.department,
			location: profileData.location,
			orgId,
		}),
	);

	return (
		<Inline alignInline="end">
			<TeamsLinkButton
				href={`https://user-shard-explorer.atlassian.com/user?data=${data}`}
				intent="external"
				appearance="primary"
				iconAfter={LinkExternalIcon}
			>
				{intl.formatMessage(messages.suggestChanges)}
			</TeamsLinkButton>
		</Inline>
	);
}
